export default __webpack_public_path__ + "static/azure-synapse-analytics-services-header-fc5f7d9d1860ef4f5b7e24513991b52e.svg";